<template>
  <div class="heading">
    <!-- <i class="material-icons">import_contacts</i> -->
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "Heading",
  props: ["text", "name"]
};
</script>

<style scoped>
.heading {
  width: 100%;
  border-bottom: 0px solid #e6e6e6;
  padding: 0.4em 0;
  padding-left: 228px;
  font-weight: 500;
  font-size: 19pt;
  font-family: "Source Sans Pro";
  color: #222;
  text-align: left;
}
</style>